import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import numeral from "numeral";

function LineGraph({ country, casesType = "cases", ...props }) {
  const [data, setData] = useState({});

  const options = {
    legend: {
      display: false,
    },
    gridLines: {
      drawBorder: false,
    },
    elements: {
      point: {
        radius: 0,
      },
    },
    maintainAspectRatio: !props.windowLarge,
    tooltips: {
      mode: "index",
      intersect: false,
      callbacks: {
        label: function (tooltipItem, data) {
          return numeral(tooltipItem.value).format("+0,0");
        },
      },
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
            drawBorder: false,
          },
          type: "time",
          time: {
            format: "MM/DD/YY",
            tooltipFormat: "ll",
          },
        },
      ],
      yAxes: [
        {
          // gridLines: {
          //   display: false,
          // },
          ticks: {
            //include a $ sign in the ticks
            callback: function (value, index, values) {
              return numeral(value).format("0a");
            },
          },
        },
      ],
    },
  };

  const buildChartData = (data, casesType = "cases") => {
    const chartData = [];
    let lastDataPoint;

    // data[casesTypes].forEach((date) =>
    for (let date in data.cases) {
      if (lastDataPoint) {
        const newDataPoint = {
          x: date,
          y: data[casesType][date] - lastDataPoint,
        };
        chartData.push(newDataPoint);
      }
      lastDataPoint = data[casesType][date];
    }
    return chartData;
  };

  //////////

  useEffect(() => {
    // to fetch inside the useEffect do like below

    const fetchData = async () => {
      await fetch(
        `https://disease.sh/v3/covid-19/historical/${
          country === "worldwide" ? (country = "all") : country
        }?lastdays=120`
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          let chartData =
            country === "all" ||
            data.message ===
              "Country not found or doesn't have any historical data"
              ? buildChartData(data, casesType)
              : // : console.log(data.timeline);
                buildChartData(data.timeline, casesType);
          setData(chartData);
        });
    };
    fetchData();
  }, [casesType, country]);

  return (
    <div className={props.className}>
      {data?.length > 0 && (
        <Line
          options={options}
          data={{
            datasets: [
              {
                data: data,
                backgroundColor: "rgba(255,111,50,0.5)",
                borderColor: "#FF6F32",
              },
            ],
          }}
        />
      )}
    </div>
  );
}

export default LineGraph;
